import { Component, Input, OnInit } from '@angular/core';
import { FilterOptionType } from 'src/app/library/enums/filters/filter.enum';
import { IFilter } from 'src/app/library/interfaces/filters/filter';
import { IFilterOption } from 'src/app/library/interfaces/filters/filter-option';
import { FilterService } from 'src/app/library/services/filter/filter.service';

@Component({
    selector: 'filter-single-select',
    templateUrl: './filter-single-select.component.html',
    styleUrls: ['./filter-single-select.component.scss']
})
export class FilterSingleSelectComponent implements OnInit {
    @Input() filter: IFilter;

    public dataTypeEnum = FilterOptionType;

    constructor(private filterService: FilterService) {}

    ngOnInit() {}

    public removeFilter() {
        this.filterService.removeFilter(this.filter);
        this.filterService.filterChangeEvent();
    }

    public selectOption(obj: IFilterOption) {
        let currentVal = this.filterService.filterConfig;
        let filterVal = currentVal.filters.find(
            e => e.field == this.filter.field
        );
        if (filterVal) {
            filterVal.options.forEach(e => (e.isSelected = false));
            let optionVal = filterVal.options.find(e => e.value == obj.value);
            if (optionVal) {
                optionVal.isSelected = true;
                this.filterService.filterConfig = currentVal;
                this.filterService.filterChangeEvent();
            }
        }
    }

    get selectedOption() {
        return this.filter.options?.find(e => e.isSelected);
    }

    get isMostRecentFilter() {
        return (
            this.filterService.mostRecentFilter()?.field == this.filter.field
        );
    }

    get addedFilterLength() {
        return this.filterService.filterConfig.filters.filter(e => e.added)
            .length;
    }
}
